<template>
    <div class="editDiary-module black">
        <div class="flex flex-y-center flex-start mb-10">
            <img class="icon middle" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/archives.png"
                alt="" />
            <div class="bold font34">{{ detail.therapists }}-服务日志</div>
        </div>
        <div class="font24 mb-50">{{ detail.createDate }}</div>
        <div class="flex flex-around mb-40 font28">
            <div class="title">护理门店</div>
            <div class="info">{{ detail.storeName }}</div>
        </div>
        <div class="flex flex-around mb-40 font28">
            <div class="title">美疗师</div>
            <div class="info">{{ detail.therapists }}</div>
        </div>
        <div class="flex flex-around mb-40 font28">
            <div class="title">开单顾问</div>
            <div class="info">{{ detail.counselorName }}</div>
        </div>
        <div class="line mb-50"></div>
        <textarea class="descContent font30" v-model="detail.remark" placeholder="请输入内容" adjust-position="false"
            cursor-spacing="100"></textarea>
        <div @click="saveRemark" class="save-btn">提交保存</div>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    name: "editDiary",
    data() {
        return {
            detail: {},
            phone: ""
        };
    },
    mounted() {
        let data = JSON.parse(this.$route.query.data);
        this.detail = data;
        this.custId = data.custId
        this.phone = this.$route.query.phone
    },
    methods: {
        // 保存

        saveRemark() {
            let dto = {
                companyCode: 25001,
                ...this.detail,
            };
            if (this.detail.remark) {
                request({
                    url: `/nursing`,
                    method: "post",
                    data: dto,
                }).then((res) => {
                    if (res.code == 0) {
                        this.$toast({
                            message: "保存成功",
                        });
                        if (this.phone) {
                            this.$router.push({
                                name: "customerDetail",
                                query: { custId: this.custId, phone: this.phone },
                            });
                        }
                        else {
                            this.$router.push({ name: "HomePage", query: {}, });
                        }

                    }
                });
            } else {
                this.$toast({
                    message: "请输入备注",
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.black {
    color: #35434c;
}

.gray {
    color: #a0acb5;
}
/* ------- */
.editDiary-module {
    width: 750px;
    overflow-x: hidden;
    padding: 40px 30px;
    box-shadow: inset 0px 2px 10px -11px rgba(0, 0, 0, 0.8);
}
.icon {
    width: 40px;
    height: 40px;
    margin-right: 27px;
}
.title {
    width: 168px;
}
.info {
    flex: 1;
    text-align: right;
}
.line {
    width: 100%;
    height: 1px;
    background: #d7d7d7;
}
.descContent {
    width: 690px;
    height: 310px;
    background: #f6f6f6;
    border-radius: 16px;
    border: 1px solid #979797;
    padding: 30px;
    color: #a0acb5;
    box-sizing: border-box;
}
.save-btn {
    width: 520px;
    height: 90px;
    background: #333f48;
    border-radius: 45px;
    margin: 375px auto 0;
    color: #fff;
    line-height: 90px;
    text-align: center;
    font-size: 30px;
}
:deep(textarea) {
    color: #333f48;
    -webkit-text-fill-color: #333f48; // ios 和 安卓9.0 必须添加此属性，才会生效
}
</style>
